module.exports = __webpack_public_path__ + "img/code-js-xs.29ad667d.webp";